import React from 'react';
import { useTranslation, Text, Link } from '@weareconceptstudio/core';
import { useGoogleReviews } from '@/libs/hooks';

//* Components
import Rating from './Rating';
import Button from '@/components/Button';

//* Style
import RatingAndReviewStyle from './style';

const googleReviewWriteLinkKey = process.env.APP_GOOGLE_REVIEW_WRITE_LINK_KEY;
const googleReviewListLinkKey = process.env.APP_GOOGLE_REVIEW_LIST_LINK_KEY;

const RatingAndReview = ({ className }) => {
	const { translate } = useTranslation();
	const { data } = useGoogleReviews();

	if (!data) {
		return null;
	}

	const { success, averageRating, totalReviewCount } = data;

	return success ? (
		<RatingAndReviewStyle className={className || ''}>
			<div className='wrapper-content'>
				<Rating rate_count={Math.round(averageRating * 10) / 10} />

				{totalReviewCount ? (
					<Link
						external
						url={googleReviewListLinkKey}
						className={'revive-link'}>
						<Text className={'p p3 font-montserrat-arm-bold underline color-hover capitalize'}>
							{totalReviewCount} {translate('googleReviews')}
						</Text>
					</Link>
				) : null}
			</div>

			<div className='review-btn-block'>
				<Button
					external
					text={'writeReview'}
					url={googleReviewWriteLinkKey}
				/>
			</div>
		</RatingAndReviewStyle>
	) : null;
};

export default RatingAndReview;
